import React from 'react';

const FacebookIconSvg = () => (
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        style={{ border: '2px solid #D9D9D9', borderRadius: 4 }}
    >
        <g transform="scale(0.6) translate(15, 15)">
            <path
                fill="#2177ff"
                d="M24 5c-10.493 0-19 8.507-19 19s8.507 19 19 19 19-8.507 19-19-8.507-19-19-19z"
            />
            <path
                fill="#ffffff"
                d="M26.572 29.036h4.917l.772-4.995h-5.69v-2.73c0-2.075.678-3.915 2.619-3.915h3.119v-4.359c-.548-.074-1.707-.236-3.897-.236-4.573 0-7.254 2.415-7.254 7.917v3.323h-4.701v4.995h4.701v13.729c.931.14 1.874.235 2.842.235.875 0 1.729-.08 2.572-.194z"
            />
        </g>
    </svg>
);

export default FacebookIconSvg;
